import React from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { DatePicker, Row, Col, Button, Select } from 'antd';
import { WrappedFormUtils } from '@ant-design/compatible/lib/form/Form';
import componentValues from '../../../../services/utilities/ComponentValue';
import { store } from '../../../../redux/store';
import { FormattedMessage } from 'react-intl';

interface Prop {
  form: WrappedFormUtils;
  handleSubmitReport: any;
}
const StartEndDateTrcReport: React.FC<Prop> = ({ form, handleSubmitReport }) => {
  const { getFieldDecorator } = form;
  const { email } = store.getState().user;
  const { Option } = Select;

  return (
    <div>
      <Row gutter={componentValues.gutterValue}>
        <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }}>
          <Form.Item label={<FormattedMessage id="startDate" />}>
            {getFieldDecorator('startDate', {
              rules: [
                {
                  required: true,
                  message: 'please select statement date',
                },
              ],
            })(<DatePicker />)}
          </Form.Item>
        </Col>
        <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }}>
          <Form.Item label={<FormattedMessage id="endDate" />}>
            {getFieldDecorator('endDate', {
              rules: [
                {
                  required: true,
                  message: 'please select statement date',
                },
              ],
            })(<DatePicker />)}
          </Form.Item>
        </Col>
        <Col xs={{ span: 24 }} sm={{ span: 12 }} md={{ span: 8 }}>
          <Form.Item label={<FormattedMessage id="trc" />}>
            {getFieldDecorator('filterTrc', {
              rules: [
                {
                  required: true,
                  message: 'please select report name',
                },
              ],
            })(
              <Select placeholder="Please select trc">
                <Option value="ALL">ALL</Option>
                <Option value="CD">CD</Option>
                <Option value="BC">BC</Option>
                <Option value="CT">CT</Option>
                <Option value="PP">PP</Option>
                <Option value="CS">CS</Option>
                <Option value="PR">PR</Option>
                <Option value="WAB">WAB</Option>
                <Option value="WAM">WAM</Option>
                <Option value="WAC">WAC</Option>
                <Option value="LC">LC</Option>
              </Select>,
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={24} style={{ textAlign: 'right' }}>
          <Button style={{ marginLeft: 8 }} type="primary" onClick={handleSubmitReport}>
            {<FormattedMessage id="comon.sendTo" />}
            &nbsp;
            {`${email}`}
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default StartEndDateTrcReport;
